// src/components/ConfirmDrawer.jsx
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

/**
 * Drawer latéral simple
 * - Z élevé pour passer au-dessus de la barre de nav
 * - Fermeture via backdrop + ESC
 * - Bloque le scroll du fond quand ouvert
 * - Boutons d'action placés juste sous le message (pas de footer sticky)
 */
export default function ConfirmDrawer({
  open,
  title = 'Confirmer',
  message = '',
  onCancel,
  onConfirm,
  confirmLabel = 'Confirmer',
}) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === 'Escape' && onCancel?.();
    document.addEventListener('keydown', onKey);

    // lock scroll arrière-plan
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev || '';
    };
  }, [open, onCancel]);

  if (!open) return null;
  const node = (
    <div className="fixed inset-0 z-[100]">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/30" onClick={onCancel} />

      {/* Panel */}
      <aside className="absolute inset-y-0 right-0 w-full max-w-md bg-white shadow-2xl flex flex-col">
        {/* Header */}
        <header className="px-4 py-3 border-b">
          <h2 className="text-lg font-semibold">{title}</h2>
        </header>

        {/* Contenu scrollable (texte + actions) */}
        <section className="px-4 py-4 overflow-auto">
          {/* Message */}
          <p className="text-sm text-gray-700">{message}</p>

          {/* Actions — immédiatement sous le texte */}
          <div className="mt-4 flex justify-end gap-2">
            <button onClick={onCancel} className="px-3 py-2 border rounded hover:bg-gray-50">
              Annuler
            </button>
            <button
              onClick={onConfirm}
              className="px-3 py-2 rounded bg-red-600 text-white hover:opacity-90"
            >
              {confirmLabel}
            </button>
          </div>
        </section>
      </aside>
    </div>
  );
  return createPortal(node, document.body);
}
